<template>
  <div class="container">
    <pcTabBarComponent tabBarKey="user" />
    <pcUserNavComponent tabBarKey="setting">
      <div class="setting-conatier">
        <div class="page-container">
          <div class="page-title-item">
            <div class="title-item active">账户设置</div>
          </div>
        </div>
        <div class="page-content-item">
          <div class="header-item">
            <div class="img img-cover">
              <img v-if="userInfo.Header" :src="userInfo.Header" />
              <img v-else src="../../assets/images/default-header.png" />
            </div>
            <van-uploader class="add-btn" name="Photo" :preview-image="false" :deletable="false" :after-read="handleUploadHeader">
              <div class="btn">上传新头像</div>
            </van-uploader>
          </div>
          <div class="detail-item">
            <div class="item">
              <div class="name">用户昵称</div>
              <div class="value flex-1">{{ userInfo.Nickname }}</div>
              <div class="btn" @click="handleEditNickname">编辑</div>
            </div>
            <div class="item">
              <div class="name">用户ID</div>
              <div class="value">{{ userInfo.Id }}</div>
              <img class="copy" src="../../assets//pc-images/copy-icon.png" @click="handleCopy(userInfo.Id)" />
            </div>
            <div class="item">
              <div class="name">手机号</div>
              <div class="value flex-1">{{ userInfo.Phone }}</div>
              <div class="btn" @click="handleEditPhone">更改</div>
            </div>
            <div class="item">
              <div class="name">重置密码</div>
              <div class="flex-1"></div>
              <div class="btn" @click="handleEditPwd">更改</div>
            </div>
            <div class="item">
              <div class="name">绑定微信</div>
              <div class="flex-1"></div>
              <div v-if="userInfo.OpenId" class="btn gray" @click="handleUnbingWx">解除绑定</div>
              <wxLoginComponent v-else @onGetOpenId="handleOnGetOpenId">
                <div class="btn">立即绑定</div>
              </wxLoginComponent>
            </div>
          </div>
        </div>
      </div>
    </pcUserNavComponent>
    <settingNicknameComponent ref="settingNicknameDialog" @success="onSuccess" @close="onClose('nickname')" />
    <settingPhoneComponent ref="settingPhoneDialog" @success="onSuccess" @close="onClose('phone')" />
    <settingPwdComponent ref="settingPwdDialog" @success="onSuccess" @close="onClose('pwd')" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import pcTabBarComponent from '@/components/pcTabBarComponent'
import pcUserNavComponent from '@/components/pcUserNavComponent'
import settingNicknameComponent from './SettingNicknameComponent.vue'
import settingPhoneComponent from './SettingPhoneComponent.vue'
import settingPwdComponent from './SettingPwdComponent.vue'
import wxLoginComponent from '../../components/wxLoginComponent.vue'

export default {
  name: "User",
  components: {
    pcTabBarComponent,
    pcUserNavComponent,
    settingNicknameComponent,
    settingPhoneComponent,
    settingPwdComponent,
    wxLoginComponent
  },
  data() {
    return {
      dialog: {
        nickname: false,
        phone: false,
        pwd: false,
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  mounted() {
    
  },
  methods: {
    ...mapActions(['GetUserInfo']),
    handleCopy(text) {
      this.$copyText(`${text}`).then(() => {
        this.$toast('复制成功')
      }).catch(() => {
        this.$toast('复制失败')
      })
    },
    onSuccess() {
      this.GetUserInfo()
    },
    onClose(key) {
      this.dialog[key] = false
    },
    handleUnbingWx() {
      this.handleEditUserInfo('OpenId', -1)
    },
    handleOnGetOpenId(openId) {
      this.handleEditUserInfo('OpenId', openId)
    },
    async handleUploadHeader(file) {
      var res = await this.$API.upload.post(file[0])
      if (res.error == 0) {
        this.handleEditUserInfo('Header', res.info)
      } else {
        this.$dialog.alert({
          type: 'danger',
          className: 'pc-dialog',
          title: '提示',
          message: res.info,
          confirmButtonText: '确定',
        })
      }
    },
    async handleEditUserInfo(key, value) {
      var res = await this.$API.userInfo.post({
        Switch: 2,
        [key]: value
      })
      if (res.error == 0) {
        this.$toast.success(res.info)
        this.GetUserInfo()
        return true
      } else {
        this.$dialog.alert({
          type: 'danger',
          className: 'pc-dialog',
          title: '提示',
          message: res.info,
          confirmButtonText: '确定',
        })
        return false
      }
    },
    handleEditNickname() {
      this.dialog.nickname = true
      this.$nextTick(() => {
        this.$refs.settingNicknameDialog.open()
      })
    },
    handleEditPhone() {
      this.dialog.phone = true
      this.$nextTick(() => {
        this.$refs.settingPhoneDialog.open()
      })
    },
    handleEditPwd() {
      this.dialog.pwd = true
      this.$nextTick(() => {
        this.$refs.settingPwdDialog.open()
      })
    },
  },
}

</script>

<style lang="less" scoped>
.setting-conatier {
  background-color: #fff;
  border-radius: 5px;
  padding: 0 15px;
}
.page-title-item {
  padding-top: 10px;
  border-bottom: 1px solid #e5e5e5;
  .title-item {
    width: 112px;
    line-height: 48px;
    text-align: center;
    border-bottom: 2px solid transparent;
    color: #64748b;
    font-size: 18px;
    &.active {
      border-bottom-color: #5783fc;
      color: #5783fc;
    }
  }
}
.page-content-item {
  padding: 25px 0;
  display: flex;
  .header-item {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-right: 45px;
    .img {
      width: 65px;
      height: 65px;
      border-radius: 50%;
      overflow: hidden;
    }
    .add-btn {
      cursor: pointer;
      margin-top: 10px;
      font-size: 12px;
      color: #2563eb;
      /deep/.van-uploader__wrapper {
        margin: 0;
      }
    }
  }
  .detail-item {
    flex: 1;
    .item {
      padding: 15px 18px;
      border-bottom: 1px solid #e5e5e5;
      display: flex;
      align-items: center;
      font-size: 18px;
      height: 28px;
      .name {
        width: 92px;
        color: #64748b;
      }
      .value {
        color: #383838;
      }
      .btn {
        font-size: 12px;
        color: #2563eb;
        cursor: pointer;
        &.gray {
          color: #64748b;
        }
      }
      .copy {
        margin-left: 10px;
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }
  }
}
</style>